/**
* List Module
* Pack of all list components and services
**/

//Core
import { NgModule, ModuleWithProviders }       from '@angular/core';
import { CommonModule }       from '@angular/common';

import { GenericModule } from './generic.module';
import { UIModule } from '../ui/ui.module';
import { PersonModule } from './person.module';

//Services
import { RoutingService } from '../service/routing/routing.service';
import { DatePipeModule } from '../date/date.module';
import { TravellerSynchronymeComponentModule } from '../component/travellersynchronyme/travellersynchronymeComponent.module';
import { CardModule } from '../ui_card/card.module';

@NgModule({
    imports: [
        CommonModule
        , GenericModule
        , UIModule
        , PersonModule
        , DatePipeModule
        , TravellerSynchronymeComponentModule
        , CardModule
    ],
    declarations: [
    ],
    exports: [
    ],
    bootstrap: [
    ],
    providers: [
        RoutingService
    ]
})
export class AirModule { }
